import { useEffect, useState } from 'react'
import { BirdLogo, IntegrationIcon, ClioIntRectIcon, ClioIcon, InfoCircleIcon } from '../../../icon'
import ButtonComponent from '../../shared/button/button.component'
import { ToasterTexts, buttonLabels, pageTitles } from '../../shared/constants'
import { setBackHandler, setHeaderTitle } from '../../../helpers/header.helper'
import Config from '../../../config'
import { useLocation, useNavigate } from 'react-router'
import { UserService } from '../../../services/UserService'
import setToast from '../../../helpers/toaster.helper'
import { ToasterType } from '../../shared/toaster/toaster.model'
import { AppRoutes, TeamsRoutes, } from '../../routes/route.path'
import { IntegrationSetupService } from '../../../services/IntegrationSetup'
import { ContactService } from '../../../services/ContactService'
import * as selector from "../../../selectors/selectors";
import { useSelector } from 'react-redux'
import { app, authentication } from "@microsoft/teams-js";
import { PhoneNumberModel } from '../../../models/phone-number.model'
import { Autocomplete, Checkbox, FormControlLabel, Radio, RadioGroup, TextField } from '@mui/material'
import { UtilityService } from '../../../services/UtilityService'
import AnimateLoader from "../../shared/loaders/animate-loader.component";
import messagsLogsLoader from "../../shared/loaders/message-logs-search-inprogress-loader.json";
import CustomSwitch from '../../shared/switch.component'
import { TimeZoneModel } from '../../../models/settings-model'

const ClioSetup = () => {
    const location = useLocation();
    const navigate = useNavigate()
    const OrgRef = UserService.getCurrentUserOrgRef()
    const OrgId = UserService.getCurrentUserOrgId()
    const Phonenumber = UserService.getUserPhoneNumber()
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp);
    const IsContactSyncing = useSelector(selector.IscontactsSyncing)
    const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers);

    const [isConnected, setIsconnected] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [syncAllLoading, setSyncAllLoading] = useState<boolean>(false)
    const [data, setdata] = useState<{
        phonenumbers: any[]
        timeZone: TimeZoneModel
        isMattersEnabled: boolean
        isLatestMatter: boolean
    }>()
    const [selectedPhonenumbers, setSelectedPhonenumbers] = useState<any[]>([]);
    const [conversationsync, setConversationsync] = useState<{
        syncInbound: boolean,
        syncOutbound: boolean
    }>({
        syncInbound: true,
        syncOutbound: true
    })

    const [isMattersEnabled, setIsMattersEnabled] = useState<boolean>(false)
    const [isLatestMatter, setIsLatestMatter] = useState<boolean>(false)

    let timeZonesTypes = UtilityService.getTimeZones();
    const [timeZone, setTimeZone] = useState<TimeZoneModel | null>(null);

    useEffect(() => {
        setHeaderTitle(pageTitles.CLIO)
        setBackHandler(() => navigate(AppRoutes.INTEGRATIIONS))

        if (!!location.search) {
            const params = new URLSearchParams(location.search);
            setIsconnected(params.get('connection') === 'true')
        }

        if (isConnected === true) {
            setToast(ToasterTexts.CLIO_CONNECTION_SUCCESS, ToasterType.SUCCESS)
        }
    }, [location?.search])

    // useEffect(() => {
    //     if (isConnected === true) {
    //         const data = {
    //             OrgId: OrgId,
    //             name: IntegrationLabels.CLIO,
    //             integrationCode: IntegrationSetupService.ClioIntegration_Code,
    //             integrationStatus: isConnected
    //         }
    //         IntegrationSetupService.updateIntegrationStatus(data).then((res) => console.log(res)).catch()
    //     }
    // }, [isConnected])

    useEffect(() => {
        if (isConnected === true && !!PhoneNumbers?.length) {
            IntegrationSetupService.getClioConfig().then((res => {
                const timeZone = timeZonesTypes?.find(x => x.Name === res.data.timeZone)
                setIsLoading(false)
                setdata({
                    ...data,
                    phonenumbers: PhoneNumbers.filter(x => res.data.phoneNumbers?.includes(x.PhoneNumber)),
                    isLatestMatter: res.data.isLatestMatters,
                    isMattersEnabled: res.data.isMattersEnabled,
                    timeZone: timeZone,
                })
                setSelectedPhonenumbers(PhoneNumbers.filter(x => res.data.phoneNumbers?.includes(x.PhoneNumber)))
                setIsLatestMatter(res.data.isLatestMatter)
                setIsMattersEnabled(res.data.isMattersEnabled)
                setTimeZone(timeZone || null)
            })).catch((err) => setIsLoading(false));
        }
    }, [isConnected, PhoneNumbers])

    const connectToClio = () => {
        if (IsTeamsApp) {
            app.initialize()
            authentication.authenticate({
                url: TeamsRoutes.CLIO_POPUP,
                width: 800,
                height: 600,
                successCallback: (result) => {
                    navigate(AppRoutes.CLIO + `?connection=${true}`)
                },
                failureCallback: (reason) => {
                    console.error('Authentication failed:', reason);
                }
            })
        }
        else {
            window.location.href = `${Config.API_URL}/api/ClioIntegration/Connect?OrgRef=${OrgRef}&OrgId=${OrgId}&PhoneNumber=${Phonenumber}`;
        }

    }

    const disconnect = () => {
        IntegrationSetupService.disConnectClio(OrgRef, OrgId).then(
            (res) => {
                setIsconnected(false)
                navigate(AppRoutes.CLIO + `?connection=${false}`)
                setToast(ToasterTexts.CLIO_DISCONNECT, ToasterType.SUCCESS)
                // const data = {
                //     OrgId: OrgId,
                //     name: IntegrationLabels.CLIO,
                //     integrationCode: IntegrationSetupService.ClioIntegration_Code,
                //     integrationStatus: false
                // }
                // IntegrationSetupService.updateIntegrationStatus(data).then((res) => console.log(res)).catch()

            }).catch((err) => { setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER) })
    }

    const SyncALLContacts = () => {
        setSyncAllLoading(true);
        ContactService.copyContactToCLio().then(res => {
            setSyncAllLoading(false);
        }
        ).catch((err) => {
            setSyncAllLoading(false);
            if (!!err?.response?.data.message) setToast(err?.response?.data.message, ToasterType.DANGER);
        })
    }

    const handleSave = () => {
        let data = {
            "phoneNumbers": selectedPhonenumbers.map(x => x.PhoneNumber),
            "timezone": timeZone?.Name,
            "isLatestMatter": isLatestMatter,
            "isMattersEnabled": isMattersEnabled,
        }
        setIsLoading(true)
        IntegrationSetupService.updateClioConfig(data).then((res) => {
            setIsLoading(false)
            setSelectedPhonenumbers(PhoneNumbers.filter(x => res.data.phoneNumbers.includes(x.PhoneNumber)))
            setIsLatestMatter(res.data.isLatestMatter)
            setIsMattersEnabled(res.data.isMattersEnabled)
            setTimeZone(timeZonesTypes?.find(x => x.Name === res.data.timeZone) || null)
            setToast(ToasterTexts.CLIO_SETTINGS_UPDATED, ToasterType.SUCCESS)
        }).catch()
    }

    const handleCancel = () => {
        setSelectedPhonenumbers(data.phonenumbers)
        setIsLatestMatter(data.isLatestMatter)
        setIsMattersEnabled(data.isMattersEnabled)
        setTimeZone(data.timeZone)
    }

    const handleSwitch = (checked) => {
        setIsMattersEnabled(checked)
    }

    const handleTimeZone = (event: any, value: any | null) => {
        if (value) {
            setTimeZone({ ...value } as TimeZoneModel)
        }
        else {
            setTimeZone({ ...value } as TimeZoneModel)
        }
    }
    return (
        <div className='d-flex w-p-100 h-p-100 bg-color-profile-primary-background'>
            <div className="d-flex flex-direction w-fill h-fill  m-1 bg-color-secondary br-5">
                <div className="d-flex w-fill bg-color-integrate-ms-teams-header brt-5">
                    <span className="mt-3"><ClioIntRectIcon /></span>
                    <span className="h1-semibold my-auto">Clio</span>
                    <span className="my-auto mx-2"><IntegrationIcon /></span>
                    <span className="my-auto mx-2"><BirdLogo /></span>
                    {
                        isConnected && <div className="d-flex my-auto ml-auto mr-3">
                            <ButtonComponent Variant={IsContactSyncing ? "disabled-btn" : "primary-btn"}
                                Loading={syncAllLoading}
                                OnClick={SyncALLContacts}
                                Type="button"
                                ButtonLabel={IsContactSyncing ? buttonLabels.SYNCING : buttonLabels.SYNC_ALL_CONTACTS}
                                ClassName='mx-2'

                            />
                            <ButtonComponent Variant={"primary-btn"}
                                OnClick={disconnect}
                                Type="button"
                                ButtonLabel={buttonLabels.DISCONNECT}
                            />
                        </div>
                    }
                </div>
                <div className="d-flex bg-color-secondary justify-around w-p-100 my-2 flex-wrap h-p-90 align-center">
                    {isConnected === false ?
                        <div className='d-flex align-center justify-between pl-2 pr-2 bg-color-settings-background p-2'>
                            <div className='paper-background h-23 min-w-75 dialogue-shadow br-1 p-2'>
                                <ClioIcon className=" h-3 w-6 ml-1" />
                                <div className='bb-primary-divider-4 opacity-1' />
                                <div className='d-flex align-center justify-center justify-between h-20'>
                                    <div className='pl-1 max-w-48 d-flex flex-direction'>
                                        <span className='h5-regular'>
                                            Clio integration enables seamless synchronization of customer contacts between Falkon SMS and Clio accounts.
                                            Additionally, customer conversations (text messages) will be instantly synced with the corresponding Clio contact cards.
                                        </span>
                                        <span className='h5-regular'>
                                            Click the 'Connect' button to set up the integration. You will be prompted to log in to Clio and approve the integration.
                                        </span>
                                    </div>
                                    <ButtonComponent
                                        ButtonLabel={buttonLabels.CONNECT_CLIO}
                                        ClassName={"br-5 max-w-20 h6-regular mr-2"}
                                        Variant={"secondary-btn-small"}
                                        OnClick={connectToClio}
                                    />
                                </div>
                            </div>
                        </div> :
                        <div className='d-flex align-center justify-between pl-1 pr-1 bg-color-settings-background p-1 br-2'>
                            <div className='paper-background h-63 w-110 dialogue-shadow br-1 px-2 o-y-scroll pt-1'>
                                {/* <div className='d-flex justify-center '>
                                    <span className='h3-regular color-contact-active'>Clio Integration is Live!</span>
                                </div>
                                <div className='d-flex flex-direction pt-2'>
                                    <div className='d-flex'>
                                        <SucessOutlineIcon className="h-1 pt-1" />
                                        <div className='h5-regular'>
                                            New contacts added to your Falkon SMS phone numbers will be directly added to your Clio account contacts in real-time.</div>
                                    </div>
                                    <div className='d-flex'>
                                        <SucessOutlineIcon className="h-1 pt-1" />
                                        <div className='h5-regular'>
                                            New contacts added to your Clio contacts will be directly added to your Falkon SMS accounts (phone numbers) in real-time.</div>
                                    </div>
                                    <div className='d-flex'>
                                        <SucessOutlineIcon className="h-1 pt-1" />
                                        <div className='h5-regular'>To manually sync contacts between Falkon SMS phone numbers and Clio contacts, use the ' Sync all contacts ' button.</div>
                                    </div>
                                    <div className='d-flex'>
                                        <SucessOutlineIcon className="h-1 pt-1" />
                                        <div className='h5-regular'> Both outbound and inbound messages in your Falkon SMS will be added to the respective Clio contact's communications log (email log).</div>
                                    </div>
                                    <div className='pt-2 pl-1' >
                                        <span className='h5-bold color-vigenary-light pr-1'>Note:</span>
                                        <span className='h5-regular'>
                                            Message sync starts with messages sent after the integration is activated. Previous message history will not be included. Only messages associated with contacts
                                            already existing in Clio  will be synced. During contact sync, if duplicate contact numbers are present, they will not be added.
                                        </span>
                                    </div>
                                </div> */}
                                <div className='d-flex '>
                                    <span className='h2-semibold '>Integration Settings</span>
                                </div>
                                <div className='d-flex flex-direction mt-1'>
                                    <div className='h4-semibold'> Falkon phone numbers </div>
                                    <div className='h6-regular color-con-hist-msg-date'>select the Phonenumbers you wish to sync contact & Messages for.</div>

                                    <Autocomplete
                                        multiple
                                        size="small"
                                        className='mt-1'
                                        classes={{ input: 'h5-regular', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                        options={PhoneNumbers}
                                        getOptionLabel={(option) => UtilityService.maskPhoneNumberOnLength(option?.PhoneNumber) + ` (${option?.Name})`}
                                        value={selectedPhonenumbers}
                                        onChange={(event, selectedOption) => {
                                            setSelectedPhonenumbers(selectedOption);
                                        }}
                                        // loading={IsLoading}
                                        renderOption={(defaultprops, option: any, { selected }) => (
                                            <li {...defaultprops}>
                                                <Checkbox
                                                    name="checkbox"
                                                    classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                                                    style={{ color: selected ? '#1450FF' : "" }}
                                                    checked={selected}
                                                />
                                                <span className={" c-pointer color-menu-list-font-color w-p-92"}>
                                                    <div className={`h5-regular ${!selector.isDarkMode ? "color-switchUIoption" : ""}`}> {UtilityService.maskPhoneNumberOnLength(option?.PhoneNumber)}</div>
                                                    <div className='h5-regular color-nav-bar-font-color'>{option?.Name} </div>
                                                </span>
                                            </li>
                                        )}
                                        renderInput={(params) =>
                                            <TextField {...params} name="phoneNumberId" required variant="outlined"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <div className='pl-2 mt-1 w-3'> {isLoading && <AnimateLoader LoaderAnimation={messagsLogsLoader} />}
                                                            {params.InputProps.endAdornment}
                                                        </div>
                                                    ),
                                                }}
                                            />}
                                    />
                                </div>
                                <div className='d-flex flex-direction  pt-1'>
                                    <div className='h4-semibold'> Message sync</div>
                                    <div className="d-flex flex-direction mt-1">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={conversationsync.syncInbound}
                                                    onChange={(e) => setConversationsync({ ...conversationsync, syncInbound: e.target.checked })}
                                                    // classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                                                    // style={{ color: !!conversationsync.syncInbound  ? '#1450FF' : " " }}
                                                    disabled={true}
                                                />}
                                            label="Sync inbound messages" />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={conversationsync.syncOutbound}
                                                    onChange={(e) => setConversationsync({ ...conversationsync, syncOutbound: e.target.checked })}
                                                    // classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                                                    // style={{ color: !!conversationsync.syncOutbound ? '#1450FF' : " " }}
                                                    disabled={true}
                                                />}
                                            label="Sync outbound messages" />
                                    </div>
                                    <div className='h6-regular color-con-hist-msg-date'> Control which direction Messages are synchronized with clio.</div>
                                </div>
                                {/* <div className="h5-regular mt-1 d-flex align-center br-2 py-1 b-around-consent-message-border color-button-text bg-color-consent-message-bg">
                                    <InfoCircleIcon className="w-p-7" />
                                    <span>Before you enable the matter syncing, please disconnect and reconnect your Clio account.</span>
                                </div> */}
                                <div className='d-flex flex-direction  pt-1'>
                                    <div className='d-flex justify-between '>
                                        <div className='h4-semibold'> Sync Messages to Contact-Assosiated Matters</div>
                                        <CustomSwitch
                                            checked={isMattersEnabled}
                                            onChange={(checked: boolean) => handleSwitch(checked)}
                                        />
                                    </div>
                                    <div className='h6-regular color-con-hist-msg-date pt-1'>Automatically logs Messages to Matters associated with the contact</div>
                                </div>
                                <div className='d-flex  flex-direction pt-2'>
                                    <div className='h4-semibold'> When a Contact is Associated With Multiple Matters</div>
                                    <RadioGroup
                                        value={isLatestMatter ? "true" : "false"}
                                        onChange={(e) => setIsLatestMatter(e.target.value === "true")}
                                    >
                                        <FormControlLabel
                                            value="true"
                                            control={<Radio color="primary" />}
                                            label="Sync messages to latest matter"
                                            disabled={!isMattersEnabled}
                                        />

                                        <FormControlLabel
                                            value="false"
                                            control={<Radio color="primary" />}
                                            label="Do not Sync Messages"
                                            disabled={!isMattersEnabled}

                                        />
                                    </RadioGroup>
                                </div>
                                <div className='d-flex flex-direction  pt-1'>
                                    <div className='h4-semibold'> Matter Message Sync Timezone</div>
                                    <Autocomplete
                                        size="small"
                                        classes={{ input: ` color-text-field-font `, paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                        options={timeZonesTypes}
                                        className='mt-2'
                                        getOptionLabel={(option: TimeZoneModel) => option && option.OffsetLabel && option.Name ? `(${option.OffsetLabel}) ${option.Name}` : ""}
                                        onChange={handleTimeZone}
                                        value={timeZone}
                                        renderOption={(defaultprops, option: any) => (
                                            <li {...defaultprops} data-name={option.Name} className={`c-pointercolor-menu-list-font-color p-2 d-flex justify-between w-p-90`}>
                                                ({option.OffsetLabel}) {option.Name}
                                            </li>
                                        )}
                                        onOpen={() => {
                                            setTimeout(() => {
                                                const element = document.querySelector(
                                                    `[data-name="${timeZone?.Name}"]`
                                                );
                                                element?.scrollIntoView({ behavior: "auto", block: "center", inline: "center" });

                                            }, 0);
                                        }}
                                        renderInput={(params) => <TextField {...params} name="Time Zone" variant="outlined" label="Time Zone" placeholder="Time Zone" />}
                                    />
                                    <div className='h6-regular color-con-hist-msg-date'> Timestamps for synced messages will use this timeZone</div>
                                </div>
                                <div className='d-flex pt-1 justify-flex-end'>
                                    <ButtonComponent OnClick={handleSave} Loading={isLoading} ButtonLabel={buttonLabels.SAVE} ClassName={`c-pointer  mr-1 w-p-10 justify-center mb-2 mr-2 br-1`} Variant={IsContactSyncing ? "disabled-btn-small" : "primary-btn-small"} />
                                    <ButtonComponent OnClick={handleCancel} ButtonLabel={buttonLabels.CANCEL} ClassName={`c-pointer 'w-p-10 justify-center  mb-2 br-1`} Variant={"secondary-btn-small"} />
                                </div>
                            </div>
                        </div>
                        //  <ClioIntegration />
                    }
                </div>
            </div>
        </div>)
}
export default ClioSetup